import * as React from "react";
import {
  createProduct,
  createSmsMessage,
  uploadPartnerDiscountLogo,
  createRule,
} from "../product/index";

import {
  Create,
  SimpleForm,
  CreateProps,
  TextInput,
  NumberInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  required,
  useRecordContext,
  SelectInput,
  FileInput,
  FileField,
  Button,
  FunctionField,
  useNotify,
  SelectArrayInput,
} from "react-admin";

import {
  makeStyles,
  TextField,
  CircularProgress,
  Snackbar,
  FormHelperText,
} from "@material-ui/core";
// @ts-ignore
const useStyles = makeStyles((theme) => ({
  width: {
    width: "30% !important",
  },
}));

const validateRequired = [required("مقدار را وارد کنید")];
const paymentGatewaysOptions = [{ label: "کارت به کارت", value: "C2C" }, { label: "پی پینگ", value: "PAYPING" }, { label: "سامان", value: "LIMOOME_SAMAN" }, { label: "دیجی پی", value: "LIMOOME_DIGIPAY" }, { label: " اسنپ پی ", value: "SNAPP_PAY"}, { label: "تارا", value: "LIMOOME_TARA"}, { label: "باسا", value: "LIMOOME_BASA"} ];

export const ProductCreate = (props: CreateProps): React.ReactElement => {
  const classes = useStyles();
  const notify = useNotify();
  const [productType, setProductType] = React.useState("DIET");
  const [currency, setCurrency] = React.useState("IRT");
  const [smsMessage, setSmsMessage] = React.useState("");
  const [logoUrl, setLogoUrl] = React.useState("");
  const [rulesEnabled,setRulesEnabled] = React.useState(true);
  const [serverState, setServerState] = React.useState({
    logo: { status: "NONE", message: "" },
  });
  const changeProductType = (e: any) => { setProductType(e.target.value);};
  const save = async (values: any) => {
    try {
      let sendData = values;
      delete sendData.rulesEnabled;
      const productData = { data: { ...sendData } };
      if (logoUrl) productData.data.logoUrl = logoUrl;
      
      const productResult = await createProduct(productData);
      let productId:any;
      productId = productResult && productResult.data.createProduct.id ?  productResult.data.createProduct.id : null; 
      if (productResult && productResult.data) {
        if(productData.data.productType === 'PARTNER_DISCOUNT'){
          await createSmsMessage(productId, smsMessage); // create after sale sms template
        }

        if (rulesEnabled) {
            await new Promise(resolve => setTimeout(resolve, 2000));
            const ruleData = await createRule({
                isEnabled: true,
                step: "BEFORE_SHOW_PRODUCT",
                ruleAddress: "http://localhost:3080/api/limoome-integrations/can-buy-diet"
            }, productId);
            console.log("ruleData", ruleData);
        }

        notify("محصول با موفقیت ایجاد شد", { type: 'success' })

      } else {

        notify("ایجاد محصول با خطا مواجه شد", { type: 'error' })

      }

  } catch (error:any) {
      console.error("Error:", error);
      if(error.message.includes("Unique constraint failed on the fields: (`id`)")){
        notify("شناسه محصول تکراری است!", { type: "error" });
      }else{
        notify(`(${error.code || 500})ایجاد محصول با خطا مواجه شد`, { type: 'error' });
      } 
  }
  
    window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Product`;

  };
  React.useEffect(() => {
    document.querySelectorAll("span").forEach((span) => {
      if (
        span.textContent &&
        (span.textContent.includes("Attachment") ||
          span.textContent.includes("Partner discount"))
      ) {
        if (span.parentElement) span.parentElement.remove(); // classList.add('disable-element')
        span.style.display = "none";
      }
    });
  });
  const changeLogoUrl = async (file: any) => {
    console.log("file: ", file);
    if (!file) {
      setLogoUrl("");
      return;
    }

    setServerState({
      ...serverState,
      logo: { ...serverState.logo, status: "PENDING" },
    });
    uploadPartnerDiscountLogo(file)
      .then((res: any) => {
        setServerState({
          ...serverState,
          logo: { message: "عکس با موفقیت آپلود شد", status: "SUCCESSFUL" },
        });
        console.log("upload res: ", res);
        setLogoUrl(`${process.env.REACT_APP_LIMOOME_SERVER}/files/${res}`);
        document
          .querySelector(".MuiSnackbarContent-root")
          ?.classList.add("snack-successful");
      })
      .catch(() => {
        setServerState({
          ...serverState,
          logo: { message: "خطا در آپلود عکس", status: "ERROR" },
        });
        document
          .querySelector(".MuiSnackbarContent-root")
          ?.classList.add("snack-error");
      });
  };

  const FieldByProductType = () => {
    if (productType === "DIET") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات رژیم
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <BooleanInput
              style={{ width: "100%" }}
              label="دارای حامی"
              source="meta.isAllowedMentor"
            />
            <TextInput fullWidth label="کد رژیم" source="meta.productCode" />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <NumberInput
              fullWidth
              label="تعداد دوره"
              source="meta.count"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روزهای دوره"
              source="meta.days"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روز انقضا"
              source="meta.expiresAfter"
              isRequired
              validate={validateRequired}
            />
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <FileInput
              onChange={(e: any) => changeLogoUrl(e)}
              className="partner-upload-file"
              accept="image/*"
              labelSingle="برای آپلود لوگو کلیک کنید"
              source="partnerDiscountLogo"
            >
              <FileField source="src" title="partner-discount" />
            </FileInput>
            {serverState.logo.status !== "PENDING" ? (
              <FunctionField
                render={(record: any) => {
                  return logoUrl ? (
                    <img style={{ width: "100px" }} src={logoUrl} alt="logo" />
                  ) : (
                    ""
                  );
                }}
              />
            ) : (
              <FunctionField
                render={(record: any) => {
                  return <CircularProgress />;
                }}
              />
            )}
          </div>
        </div>
      );
    } else if (productType === "MENTOR") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات حامی
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <NumberInput
              fullWidth
              label="تعداد دوره"
              source="meta.count"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روزهای دوره"
              source="meta.days"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              fullWidth
              label="تعداد روز انقضا"
              source="meta.expiresAfter"
              isRequired
              validate={validateRequired}
            />
            <div>
              <TextInput fullWidth label="نوع حامی" source="meta.variation" />
              <FormHelperText>
                در صورتی که محصول لیموپلاس باشد این فیلد را با مقدار LIMOO_PLUS
                پر نمایید. در غیراین صورت فیلد را خالی بگذارید.
              </FormHelperText>
            </div>
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
        </div>
      );
    } else if (productType === "PSYCHOLOGY_SESSION") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات جلسه روان‌شناسی
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <NumberInput
              style={{ width: "100%" }}
              label="تعداد جلسات"
              source="meta.count"
              isRequired
              validate={validateRequired}
            />
            <NumberInput
              style={{ width: "100%" }}
              label="مدت زمان هر جلسه(دقیقه)"
              source="meta.sessionDuration"
              isRequired
              validate={validateRequired}
            />
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
        </div>
      );
    } else if (productType === "PARTNER_DISCOUNT") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات تخفیف همکار
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <SelectInput
              fullWidth
              label="نوع تخفیف"
              source="meta.discountType"
              choices={[
                { id: "PERCENT", name: "درصد" },
                { id: "MONEY", name: "نقدی" },
              ]}
              isRequired
              validate={validateRequired}
              defaultValue="MONEY"
            />
            <NumberInput
              fullWidth
              label="مقدار"
              source="meta.amount"
              isRequired
              validate={validateRequired}
            />
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <Button
              style={{ justifyContent: "flex-end" }}
              fullWidth
              onClick={() => setSmsMessage(smsMessage + " ** ")}
              label="جایگذاری کد تخفیف در متن پیامک"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <TextField
              autoFocus
              multiline
              placeholder="متن پیامک را در این قسمت وارد کنید"
              fullWidth
              value={smsMessage}
              onChange={(e) => setSmsMessage(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <FileInput
              onChange={(e: any) => changeLogoUrl(e)}
              className="partner-upload-file"
              accept="image/*"
              labelSingle="برای آپلود لوگو کلیک کنید"
              source="partnerDiscountLogo"
            >
              <FileField source="src" title="partner-discount" />
            </FileInput>
            {serverState.logo.status !== "PENDING" ? (
              <FunctionField
                render={(record: any) => {
                  return logoUrl ? (
                    <img style={{ width: "100px" }} src={logoUrl} alt="logo" />
                  ) : (
                    ""
                  );
                }}
              />
            ) : (
              <FunctionField
                render={(record: any) => {
                  return <CircularProgress />;
                }}
              />
            )}
          </div>
        </div>
      );
    } else if (productType === "TAG") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات رژیم
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "1rem",
            }}
          >
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />

            <TextInput
              fullWidth
              validate={validateRequired}
              isRequired
              label="نام دسته"
              source="meta.value"
            />
            <TextInput
              fullWidth
              label="تایپ صفحه انتخاب بسته"
              source="meta.selectPackageType"
            />
          </div>
        </div>
      );
    } else if (productType === "PRODUCT") {
      return (
        <div style={{ border: "1px solid #7950ed", padding: "1rem" }}>
          <p
            style={{
              width: "100%",
              margin: "0px",
              textAlign: "center",
              fontFamily: "IranSans-Bold",
              backgroundColor: "#7950ed",
              color: "#fff",
              marginBottom: "2rem",
            }}
          >
            اطلاعات رژیم
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <TextInput
              fullWidth
              label="UI Component"
              source="meta.ui_component"
            />
            <TextInput
              fullWidth
              label="UI Component Badge Icon"
              source="meta.ui_component_badgeIcon"
            />

            <FileInput
              onChange={(e: any) => changeLogoUrl(e)}
              className="partner-upload-file"
              accept="image/*"
              labelSingle="برای آپلود لوگو کلیک کنید"
              source="partnerDiscountLogo"
            >
              <FileField source="src" title="partner-discount" />
            </FileInput>
            {serverState.logo.status !== "PENDING" ? (
              <FunctionField
                render={(record: any) => {
                  return logoUrl ? (
                    <img style={{ width: "100px" }} src={logoUrl} alt="logo" />
                  ) : (
                    ""
                  );
                }}
              />
            ) : (
              <FunctionField
                render={(record: any) => {
                  return <CircularProgress />;
                }}
              />
            )}
          </div>
        </div>
      );
    } else return <></>;
  };

  return (
    <Create {...props}>
      <SimpleForm style={{ direction: "rtl" }} save={save}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput
            fullWidth
            label="ID"
            source="id"
            isRequired
            validate={validateRequired}
          />
            <BooleanInput
            style={{ width: "100%" }}
            source="rulesEnabled"
            label="قابل خرید برای کاربران با رژیم فعال"
            defaultValue={!rulesEnabled}
            onChange={()=>setRulesEnabled(!rulesEnabled)}
          />
          <BooleanInput
            style={{ width: "100%" }}
            label="فعال/غیر فعال محصول"
            source="isEnabled"
            defaultValue={true}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput
            fullWidth
            disabled
            label="سرویس"
            defaultValue={process.env.REACT_APP_SERVICE}
            source="service"
            isRequired
            validate={validateRequired}
          />
          <SelectInput
            fullWidth
            label="نوع محصول"
            source="productType"
            choices={[
              { id: "DIET", name: "رژیم" },
              { id: "MENTOR", name: "حامی" },
              { id: "PSYCHOLOGY_SESSION", name: "جلسه روان‌شناسی" },
              { id: "PARTNER_DISCOUNT", name: "تخفیف همکار" },
              { id: "TAG", name: "دسته بندی" },
              { id: "PRODUCT", name: "عادی" },
            ]}
            isRequired
            validate={validateRequired}
            defaultValue="DIET"
            value={productType}
            onChange={(e: any) => changeProductType(e)}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput
            fullWidth
            label="عنوان"
            source="title"
            isRequired
            validate={validateRequired}
          />
          <TextInput fullWidth label="زیر عنوان" source="subtitle" />
          <TextInput fullWidth label="زیر عنوان دوم" source="subtitle2" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <NumberInput
            fullWidth
            label="تعداد روز انقضا سبد خرید"
            source="expiryPeriod"
            isRequired
            validate={validateRequired}
          />
          <TextInput
            fullWidth
            label="کد محصول"
            source="name"
            isRequired
            validate={validateRequired}
          />
          <NumberInput fullWidth label="ترتیب نمایش" source="meta.showOrder" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <TextInput
            fullWidth
            label="توضیحات"
            multiline
            rows={3}
            source="description"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <NumberInput
            fullWidth
            label="قیمت محصول"
            source="price"
            isRequired
            validate={validateRequired}
          />
          <SelectInput
            fullWidth
            label="واحد"
            source="currency"
            choices={[{ id: "IRT", name: "تومان" }]}
            isRequired
            validate={validateRequired}
            defaultValue="IRT"
            value={currency}
            onChange={(e: any) => setCurrency(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
          <NumberInput
            fullWidth
            label="مبلغ تخفیف"
            source="offValue"
            defaultValue={0}
            isRequired
            validate={validateRequired}
          />
          <TextInput
            fullWidth
            label="درصد تخفیف"
            source="offPercent"
            defaultValue={"0"}
          />
        </div>
        <div
        style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
<TextInput
        fullWidth
        label="وضعیت پیگیری"
        source="meta.orderTrackingUrl"
        defaultValue={""}
      />
            <TextInput
            fullWidth
            label="پیام موفقیت پرداخت "
            source="meta.paymentSuccessMessage"
            defaultValue={""} 
            />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: "1rem",
          }}
        >
      
          <p style={{ fontFamily: "IranSans-Medium" }}>تگ‌ها:</p>
          <ArrayInput
            className="tag-input"
            fullWidth
            label=" "
            source="meta.tags"
          >
            <SimpleFormIterator
              addButton={<Button label="اضافه کردن تگ"></Button>}
              removeButton={<Button label="حذف تگ" />}
            >
              <TextInput label="نام تگ" source="label" />
            </SimpleFormIterator>
          </ArrayInput>
        </div>
        <SelectArrayInput
          style={{ marginTop: '1rem' }}
          source="meta.paymentGateways"
          choices={paymentGatewaysOptions}
          optionText="label"
          optionValue="value"
          label="انتخاب درگاه پرداخت"
        />
        <FieldByProductType />
        <Snackbar
          open={
            serverState.logo.status === "ERROR" ||
            serverState.logo.status === "SUCCESSFUL"
              ? true
              : false
          }
          onClose={() => {
            setServerState({
              ...serverState,
              logo: { ...serverState.logo, status: "NONE" },
            });
          }}
          autoHideDuration={1500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          message={serverState.logo.message}
          style={{ backgroundColor: "transparent", borderRadius: "12px" }}
        />
      </SimpleForm>
    </Create>
  );
};
